var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quill-editor"},[_vm._t("default",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.data)}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }